import { render } from "./todo.vue?vue&type=template&id=3e325500&scoped=true"
import script from "./todo.vue?vue&type=script&lang=js"
export * from "./todo.vue?vue&type=script&lang=js"

import "./todo.vue?vue&type=style&index=0&id=3e325500&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e325500"]])

export default __exports__